import ConfigService from '@/service/cdn_config'

export const getConfig = async () => {
    const data = await ConfigService.getOrderCheck()
    return data
}